
import { useEffect } from "react";
import { useTrips } from "@/hooks/useTrips";
import TripListing from "./TripListing";

interface TripsTabContentProps {
  type: "booked" | "claimed" | "complete";
  activeTab: string;
  onClaimTrip?: (tripId: string) => void;
}

const TripsTabContent = ({ 
  type, 
  activeTab,
  onClaimTrip 
}: TripsTabContentProps) => {
  // Map tab values to trip types
  const getTabValue = () => {
    if (type === "booked") return "new";
    if (type === "claimed") return "upcoming";
    if (type === "complete") return "completed";
    return type;
  };
  
  const tabValue = getTabValue();
  const isActive = activeTab === tabValue;
  
  // Log the active state for debugging
  useEffect(() => {
    if (isActive) {
      console.log(`TripsTabContent for ${type} is active`);
    }
  }, [isActive, type]);
  
  const { 
    trips, 
    isLoading, 
    isError, 
    error,
    refetch
  } = useTrips({ 
    tripType: type,
    enabled: isActive
  });
  
  // Refetch when tab becomes active
  useEffect(() => {
    if (isActive) {
      console.log(`Refetching ${type} trips because tab is active`);
      refetch();
    }
  }, [isActive, refetch, type]);

  return (
    <TripListing
      trips={trips}
      isLoading={isLoading}
      isError={isError}
      error={error}
      onClaimTrip={type === "booked" ? onClaimTrip : undefined}
    />
  );
};

export default TripsTabContent;
